module.exports = __webpack_public_path__ + "img/NHorseman64_ua.2018010b.webp";